module.exports = __webpack_public_path__ + "static/img/mkf.c626980.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/mkf.png
// module id = uwl1
// module chunks = 1